const directive = [
    '$location',
];

const template = `
<nav>
    <span ng-repeat="item in crumbs">
        <span>
            <a ng-if="item.link" ng-click="goto(item.link)">{{ item.text }}</a>
            <span ng-if="!item.link">{{ item.text }}</span>
        </span>
        <span ng-if="!$last">></span>
    </span>
</nav>
`;

const fn = (
    $location
) => {
    return {
        restrict: 'E',
        scope: {
            crumbs: '=',
        },
        template,
        link: (scope) => {
            scope.goto = function(path) {
                $location.path(path);
            };
        },
    };
};

directive.push(fn);

export default directive;



// WEBPACK FOOTER //
// ./resources/assets/app-releases/directives/breadcrumb.js